// extracted by mini-css-extract-plugin
export var certifications = "CopyRightFooter-module--certifications--0I87t";
export var copyRightFooterContainerDark = "CopyRightFooter-module--copyRightFooterContainerDark--iu3q2";
export var copyRightFooterContainerLight = "CopyRightFooter-module--copyRightFooterContainerLight--IScw2";
export var copyrightDark = "CopyRightFooter-module--copyrightDark--xjh0E";
export var copyrightLight = "CopyRightFooter-module--copyrightLight--oHaUc";
export var limitWidthOnLargeScreens = "CopyRightFooter-module--limitWidthOnLargeScreens--f9ZBD";
export var linkDark = "CopyRightFooter-module--linkDark--7Xp2O";
export var linkLight = "CopyRightFooter-module--linkLight--8hJcf";
export var linksContainer = "CopyRightFooter-module--linksContainer--cV834";
export var policyContainer = "CopyRightFooter-module--policyContainer--Xf4NI";
export var policyContent = "CopyRightFooter-module--policyContent--Wb2tc";
export var socials = "CopyRightFooter-module--socials--PFUUk";